import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'welcome.to.platform': {
    id: 'welcome.to.platform',
    defaultMessage: '¡Bienvenido a {siteName}, {fullName}!',
    description: 'Welcome message that appears on progressive profile page',
  },
  'complete.your.profile.1': {
    id: 'complete.your.profile.1',
    defaultMessage: 'Completa',
    description: 'part of text "completa tu perfil"',
  },
  'complete.your.profile.2': {
    id: 'complete.your.profile.2',
    defaultMessage: 'tu perfil',
    description: 'part of text "completa tu perfil"',
  },
});

export default messages;
